import { render, staticRenderFns } from "./CustomAttributesCreateDialog.vue?vue&type=template&id=96015a0e"
import script from "./CustomAttributesCreateDialog.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports